export const SOCIAL_MEDIA = {
  instagram: 'https://www.instagram.com/fugue.lab',
  facebook: 'https://www.facebook.com/fugue.lab',
  linkedin: 'https://www.linkedin.com/company/fugue-lab',
} as const

export const CONTACT = {
  email: 'hello@fuguelab.com',
} as const
